import axios from 'axios';
import {backendHost} from '../../../../store/config';

const postCreateOrganization = (params) => {
    return axios.post(`${backendHost}/api/admin/object/create`, params);
};

export {
    postCreateOrganization
}